<template>
  <div class="category-filter-1">
    <div class="row category-filter-1-row">
      <m-a class="m-1 category-filter-1-link" target="_blank"
           :href="{name:pageName,query:{category:category.id}}"
           v-for="category in categories">
        <div class="category-filter-1-button btn btn-primary rounded-pill">{{ category.name }}</div>
      </m-a>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import mCategoriesWrapper from "../../../Wrappers/CategoryWrapper.vue";
import mA from "../../../Tags/A.vue";

export default defineComponent({
  name: "CategoriesFilter",
  components: {mCategoriesWrapper, mA},
  props: {
    categories: {},
    pageName: {
      default: 'Products'
    }
  }
})
</script>

<style scoped>

</style>